import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position on navigation. Without this, moving from a scrolled
 * page to a new one lands you partway down the new page.
 *
 * Hash links (/#solutions, #work) are left alone — those navigations exist
 * precisely to jump somewhere other than the top.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
